export default "__VITE_ASSET__34eebb9c__"